<template>
    <div class="area row-center">
        <img :src="allArea.length > 0 ? allArea[details].areaImg : require('@/assets/img/ebs.png')" alt="">
        <div class="column-center" :style="'width:' + width/1920 * 100 + 'vw; position: relative'">
            <div class="name">
                <h1>{{allArea.length > 0 ? allArea[details].areaName : '站点'}}</h1>
                <div ref="container" class="changeContainer">
                    <img class="change" src="../../assets/img/change0.png" @click="handleClick" alt="">
                    <!-- v-clickout="areaListState = false" -->
                    <div class="area-list" v-if="areaListState">
                        <div class="search row-center">
                            <input type="text" placeholder="请输入关键词" v-model="areaFilterText">
                            <img src="../../assets/img/search.png" alt="">
                        </div>
                        <div class="areas">
                            <template v-for="(item, index) in allArea">
                                <div class="row item" :key="index" v-if="areaFilter(item)" style="cursor: pointer"
                                    @click.prevent.stop="details = index, areaListState = false, areaId = item.areaId, $emit('changeSite',areaId)">
                                    <img :src="item.areaImg" alt="">
                                    <p>{{item.areaName}}</p>
                                </div>
                            </template>
                            <template v-if="showAreaNumber === 0">
                                <span style="color: #8c939d;font-size: 18rem">暂无数据</span>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
            <p class="position">{{ allArea.length > 0 ? allArea[details].areaDirection : '位置'}}</p>
        </div>
    </div>
</template>

<script>
    import {
        GET_AREAS
    } from "../../api/common";
    export default {
        name: "Area",
        props: ["width"],
        data() {
            return {
                details: -1,
                allArea: [],
                areaFilterText: "",
                areaId: -1,
                areaListState: false,
                showAreaNumber: 0,
            }
        },
        beforeMount() {
            GET_AREAS().then(res => {
                // console.log(res.data.data.areas)
                this.allArea = res.data.data.areas
                this.areaId = res.data.data.areas[0].areaId
                this.details = 0
                this.showAreaNumber = res.data.data.areas.length
                this.$emit('initAreaId', this.areaId)
            })
        },
        mounted() {
            document.addEventListener('mouseup', this.handle)
        },
        beforeDestroy() {
            document.removeEventListener('mouseup', this.handle)
        },
        watch: {
            areaFilterText(n, o) {
                if (!n) {
                    this.showAreaNumber = this.allArea.length
                } else {
                    this.showAreaNumber = this.allArea.filter(area => {
                        return area.areaName.indexOf(n) !== -1
                    }).length
                }
            },
        },
        methods: {
            handle(e) {
                let tree = this.$refs.container
                if (tree) {
                    if (!tree.contains(e.target)) {
                        this.areaListState = false
                    }
                }
            },
            areaFilter(item) {
                if (!this.areaFilterText || item.areaName.includes(this.areaFilterText)) {
                    // this.noData = false
                    return true
                }
                if (!item.areaName.includes(this.areaFilterText)) {
                    return false
                }
            },
            handleClick() {
                this.areaListState = !this.areaListState
            }
        },
    }
</script>

<style scoped lang="less">
    .area {
        position: relative;
        justify-content: space-between;
        padding: 16rem 24rem;
        border-bottom: 1px solid #E5E5E5;

        >img {
            .w(64);
            .h(64);
            margin-right: 15rem;
        }

        >div {
            .h(64);
            justify-content: space-between !important;


            p {
                width: 100%;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
                word-break: break-all;
                font-size: 16rem;
                color: #999999;
            }
        }

        .position {
            position: absolute;
            left: 0;
            bottom: 0;
        }

        .name {
            justify-content: flex-start;
            width: 100%;
            display: flex;
            flex-direction: row;
            align-items: flex-start;
            justify-content: flex-start;

            h1 {
                font-size: 24rem;
                font-weight: bold;
                color: #333333;
            }

            .changeContainer {
                display: flex;
                flex-direction: row;
                align-items: flex-start;
                justify-content: flex-start;

                .change {
                    cursor: pointer;
                    margin-left: 100/192vw;
                    margin-top: 100/108vh;
                }

                .area-list {
                    margin-top: -160/108vh;
                    margin-left: 200/192vw;
                    .w(504);
                    .h(520);
                    background-color: #fff;
                    box-shadow: 0px 4px 40px 0px rgba(0, 43, 102, 0.28);
                    padding: 24rem 16rem;
                    z-index: 999 !important;

                    .areas {
                        margin-top: 24rem;
                        cursor: pointer;
                        overflow-y: auto;
                        font-size: 16rem;
                        .h(400);
                        display: flex;
                        flex-direction: column;
                        align-items: center;

                        .row {
                            margin-bottom: 24rem;
                            display: flex;
                            justify-content: flex-start;
                            align-items: center;

                            p {
                                font-size: 16rem;
                                color: #333333;
                                font-weight: 400;
                                .w(400);
                            }

                            img {
                                .w(48);
                                .h(48);
                                margin-right: 13rem;
                                margin-left: 8rem;
                            }
                        }
                    }

                    .search {
                        .h(48);
                        width: 100%;
                        overflow: hidden;
                        border-radius: 24rem;
                        border: 1px solid rgba(0, 0, 0, 0.15);
                        position: relative;

                        input {
                            width: 100%;
                            height: 100%;
                            padding: 0 20rem;
                            font-size: 16rem;
                            color: #000000;
                            font-weight: 400;
                            line-height: 48rem;
                        }

                        img {
                            position: absolute;
                            right: 16rem;
                            top: 15rem;
                            z-index: 99;
                        }
                    }
                }
            }

        }
    }
</style>